const sliders = [...document.querySelectorAll('.carousel__list-wrapper')];

sliders.forEach(slider => {
    const slidesCount = slider.querySelectorAll('.carousel__item-wrapper').length;

    new Swiper(`#${slider.id}`, {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: slidesCount > 3,
        navigation: {
            nextEl: `#${slider.id} + .carousel__btn-wrapper .carousel__btn-next`,
            prevEl: `#${slider.id} + .carousel__btn-wrapper .carousel__btn-prev`,
        },
        breakpoints: {
            540: {
                slidesPerView: 1,
                loop: slidesCount > 1,
            },
            768: {
                slidesPerView: 2,
                loop: slidesCount > 2,
            },
        },
        on: {
            init: function () {
                toggleSwipeAndNavigation(this);
            },
            resize: function () {
                setTimeout(() => toggleSwipeAndNavigation(this), 10);
            }
        },
    });
})

function toggleSwipeAndNavigation(swiperInstance) {
    const { slides, params } = swiperInstance;
    const nextButton = document.querySelector(params.navigation.nextEl);
    const prevButton = document.querySelector(params.navigation.prevEl);

    if (slides.length <= params.slidesPerView) {
        swiperInstance.allowTouchMove = false;
        nextButton.style.display = 'none';
        prevButton.style.display = 'none';
    } else {
        swiperInstance.allowTouchMove = true;
        nextButton.style.display = 'block';
        prevButton.style.display = 'block';
    }
}


// WEBPACK FOOTER //
// ./js/main/module/swiper-carousel.js